import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { SearchModule } from './modules/search-module/search.module';
import { ProjectModule } from 'app/modules/project/project.module';
import { AppRoutingModule } from 'app/app-routing.module';
import { CoreModule } from 'app/modules/core/core.module';
import { SocialModule } from 'app/modules/social/social.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SearchModule,
    ProjectModule,
    SocialModule,
    AppRoutingModule,
    CoreModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

